import { array, object, string } from 'yup'

export const checkBeketValidate = object().shape({
  directions: array().of(
    object().shape({
      from: object()
        .shape({
          cityName: string().required(),
        })
        .required(),
      to: object()
        .shape({
          cityName: string().required(),
        })
        .required(),
      date: string().required(),
    }),
  ),
})
